import { Button } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigateToAssetOverview } from '~/hooks/use-navigate-to-asset-overview/useNavigateToAssetOverview';

import { EarningsInsightWidget } from './earnings-insight-widget/EarningsInsightWidget';
import * as S from './EarningsInsightDrawer.styles';
import { useEarningsInsightDrawer } from './useEarningsInsightDrawer';

export const EarningsInsightDrawer = () => {
  const { t } = useTranslation(['earnings']);
  const { navigateToPage } = useNavigateToAssetOverview();

  const { isDrawerOpen, closeDrawer, activeEntityTag } =
    useEarningsInsightDrawer();

  if (!activeEntityTag) {
    return null;
  }

  return (
    <S.StyledDrawer
      data-testid="earnings-insight-drawer"
      isOpen={isDrawerOpen}
      handleCloseClick={closeDrawer}
      headerButton={
        <Button
          variant="empty"
          label={t('earnings:earningsInsight.drawer.viewOnAO')}
          iconName="Expand"
          size="xsmall"
          onClick={() => navigateToPage({ entityTag: activeEntityTag })}
        />
      }
    >
      <S.ContentWrapper>
        <EarningsInsightWidget />
      </S.ContentWrapper>
    </S.StyledDrawer>
  );
};
